import initialState from './initialState';
import { types } from '../actions/accountsActions';
import { types as authTypes } from '../actions/authActions';

export default function accountReducer(state = initialState.account, action) {
  const { data } = action;
  switch (action.type) {
    case authTypes.CURRENT_USER_DATA_SUCCESS: {      
      return { fetching: false, data };
    }
    case authTypes.CURRENT_USER_DATA: {
      return { fetching: true, data: null };
    }
    case authTypes.CURRENT_USER_DATA_FAILURE: {
      return { 
        fetching: false, 
        data: null,
      };
    }
    case types.UPDATE_ACCOUNT_SUCCESS: {      
      return { 
        fetching: false, 
        data,
      };
    }    
    case types.UPDATE_SETTINGS_SUCCESS: {
      let participantAccount = {...state.data};
      participantAccount.settings = data.settings;
      return { 
        fetching: false, 
        data: participantAccount,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js